import { module } from 'angular';
import API from './model/api';

// import Utils from '~/scripts/services/utils';
// import Cache from '~/scripts/services/cache';

// export default { API };
const apiFactory = /* @ngInject */ (
	$filter,
	$http,
	$location,
	$q,
	$rootScope,
	$timeout,
	$translate,
	Notification,
	User,
) => new API(
	$filter,
	$http,
	$location,
	$q,
	$rootScope,
	$timeout,
	$translate,
	Notification,
	User,
);

/**
 * @ngdoc service
 * @name app.API
 * @description
 * # API
 * Factory in the app.
 */
export default module('app')
	.factory('API', apiFactory);
